module.exports = __webpack_public_path__ + "img/support.b79881f5.gif";